/* eslint-disable sort-keys */
export const urls: Record<
  'de-en',
  Record<string, '/l/de/en' | `/l/de/en/${string}`>
> = {
  'de-en': {
    // Home
    '': '/l/de/en/home',

    // Alumni
    alumni: '/l/de/en/alumni',

    // B2B
    enterprise: '/l/de/en/b2b',
    'enterprise/contact': '/l/de/en/b2b/apply',

    // Campus
    berlin: '/l/de/en/campus/ber',
    remote: '/l/de/en/campus/rmt',

    // Career
    career: '/l/de/en/career',

    // Courses
    'web-development': '/l/de/en/course/wd',
    'data-analytics': '/l/de/en/course/da',
    'ux-ui-design': '/l/de/en/course/ux',
    cybersecurity: '/l/de/en/course/cy',

    // FAQ
    faq: '/l/de/en/faq',

    // Financing Options
    'financing-options': '/l/de/en/financing',

    // Forms
    apply: '/l/de/en/apply',
    apply2: '/l/de/en/full-apply',
    contact: '/l/de/en/contact',
    'financing-form': '/l/de/en/financing-form',
    'thank-you': '/l/de/en/thank-you',

    // Quiz
    quiz: '/l/de/en/quiz',
    'artificial-intelligence/match': '/l/de/en/quiz-match/ai',
    'cybersecurity/match': '/l/de/en/quiz-match/cy',
    'data-analytics/match': '/l/de/en/quiz-match/da',
    'devops-cloud-computing/match': '/l/de/en/quiz-match/dv',
    'digital-marketing/match': '/l/de/en/quiz-match/mk',
    'data-science-machine-learning/match': '/l/de/en/quiz-match/ml',
    'ux-ui-design/match': '/l/de/en/quiz-match/ux',
    'web-development/match': '/l/de/en/quiz-match/wd',

    // Syllabus Forms
    'ai-consulting-integration/syllabus': '/l/de/en/syllabus/ac',
    'artificial-intelligence/syllabus': '/l/de/en/syllabus/ai',
    'cloud-engineer/syllabus': '/l/de/en/syllabus/ce',
    'cybersecurity/syllabus': '/l/de/en/syllabus/cy',
    'data-analytics/syllabus': '/l/de/en/syllabus/da',
    'data-engineering/syllabus': '/l/de/en/syllabus/de',
    'devops-cloud-computing/syllabus': '/l/de/en/syllabus/dv',
    'digital-marketing/syllabus': '/l/de/en/syllabus/mk',
    'data-science-machine-learning/syllabus': '/l/de/en/syllabus/ml',
    'ai-product-manager/syllabus': '/l/de/en/syllabus/pm',
    'ux-ui-design/syllabus': '/l/de/en/syllabus/ux',
    'web-development/syllabus': '/l/de/en/syllabus/wd',

    // PDP
    'ai-consulting-integration/remote': '/l/de/en/pdp/ac/rmt',
    'artificial-intelligence/berlin': '/l/de/en/pdp/ai/ber',
    'artificial-intelligence/remote': '/l/de/en/pdp/ai/rmt',
    'cloud-engineer/remote': '/l/de/en/pdp/ce/rmt',
    'cybersecurity/berlin': '/l/de/en/pdp/cy/ber',
    'cybersecurity/remote': '/l/de/en/pdp/cy/rmt',
    'data-analytics/berlin': '/l/de/en/pdp/da/ber',
    'data-analytics/remote': '/l/de/en/pdp/da/rmt',
    'data-engineering/remote': '/l/de/en/pdp/de/rmt',
    'devops-cloud-computing/remote': '/l/de/en/pdp/dv/rmt',
    'digital-marketing/remote': '/l/de/en/pdp/mk/rmt',
    'data-science-machine-learning/remote': '/l/de/en/pdp/ml/rmt',
    'ai-product-manager/remote': '/l/de/en/pdp/pm/rmt',
    'ux-ui-design/berlin': '/l/de/en/pdp/ux/ber',
    'ux-ui-design/remote': '/l/de/en/pdp/ux/rmt',
  },
};
/* eslint-enable sort-keys */
